import { render } from "./datatable.vue?vue&type=template&id=74e1622e&scoped=true"
import script from "./datatable.vue?vue&type=script&lang=js"
export * from "./datatable.vue?vue&type=script&lang=js"

import "./datatable.vue?vue&type=style&index=0&id=74e1622e&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e1622e"]])

export default __exports__